<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Tom Drennen is a long-time student of the American Civil War, particularly the guerrilla warfare in his home state of Missouri. After retiring from a successful career as an engineer at Sikorsky Aircraft, he turned his attention to researching what forces drove young men in the 1860s to become Jayhawkers and Bushwhackers. He is a founding member of the Shoreline Civil War Discussion Group in Connecticut. Tom is also a life-long St. Louis Cardinals fan. Go Redbirds!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?506383b4